import { render, staticRenderFns } from "./EdsWrapper.vue?vue&type=template&id=4a5c1bbe"
import script from "./EdsWrapper.vue?vue&type=script&lang=js"
export * from "./EdsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports